// extracted by mini-css-extract-plugin
module.exports = {"csr_pc_B":"B_csr_pc_B__cZFTQ"};